export default __webpack_public_path__ + "static/media/new_main_intro.352e6a6a.mp4";